// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c79e96dd","453":"8e287796","455":"2c67461f"}[chunkId] + ".chunk.js";
};